import React from "react";
import { TextField, InputAdornment, IconButton, Box } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";

const SearchBar = ({
  searchQuery,
  handleSearchChange,
  clearSearch,
  placeholder = "Search by category...",
  sx = {},
}) => {
  return (
    <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2, ...sx }}>
      <TextField
        size="small"
        variant="outlined"
        placeholder={placeholder}
        value={searchQuery}
        onChange={handleSearchChange}
        sx={{
          minWidth: 300,
          "& .MuiOutlinedInput-root": {
            "& fieldset": {
              borderColor: "#e0e0e0",
            },
            "&:hover fieldset": {
              borderColor: "#535353",
            },
            "&.Mui-focused fieldset": {
              borderColor: "#535353",
            },
          },
        }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon color="action" />
            </InputAdornment>
          ),
          endAdornment: searchQuery && (
            <InputAdornment position="end">
              <IconButton
                size="small"
                onClick={clearSearch}
                edge="end"
                sx={{
                  "&:hover": {
                    backgroundColor: "rgba(60, 176, 67, 0.1)",
                  },
                }}
              >
                <ClearIcon fontSize="small" />
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
    </Box>
  );
};

export default SearchBar;
